import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';
import { catchError, Observable, shareReplay, tap, timer } from 'rxjs';
import { ItemDoMenuDoUsuario } from '../permissoes-de-sistema/permissoes-de-sistema.service';

/** Campos de `GET /v1/menu-usuario/{id}` lidos pela resolução de permissões de botão. */
export interface MenuUsuarioResponse {
  id: string;
  tipoEntidade: { tipoEnum: string };
  profileUser: { permissaoPerfis: ItemDoMenuDoUsuario[] };
}

@Injectable({
  providedIn: 'root',
})
export class CoreService {
  private baseUrl: string;
  private menuCache$: Observable<any> | null = null;
  private expirationTimerSet: boolean = false;
  private readonly CACHE_DURATION = 30 * 60 * 1000; // 30 minutos

  constructor(
    private http: HttpClient,
    private configService: ConfigService,
  ) {
    this.baseUrl = this.configService.pessoaApi;
  }

  getMenuUsuario(userId: string): Observable<any> {
    if (!this.menuCache$) {
      this.menuCache$ = this.http
        .get(this.baseUrl + `/v1/menu-usuario/${userId}`)
        .pipe(
          shareReplay(1),
          tap(() => {
            if (!this.expirationTimerSet) {
              this.expirationTimerSet = true;
              timer(this.CACHE_DURATION).subscribe(() => {
                this.menuCache$ = null;
                this.expirationTimerSet = false;
              });
            }
          }),
          catchError((err) => {
            this.menuCache$ = null;
            throw err;
          }),
        );
    }
    return this.menuCache$;
  }

  getNotifications(pageIndex: number = 0, pageSize: number = 5) {
    return this.http.post(
      this.baseUrl +
        `/v1/menu/notificacoes?page=${pageIndex}&size=${pageSize}&sortFields=lida&sortFields=dataNotificacao&sortDirection=desc`,
      {},
      {
        headers: new HttpHeaders({
          'x-skip-loader': 'true',
        }),
      },
    );
  }
}
